import { Text } from '@/components/atoms'
import { InfoIconFilled } from '@/components/atoms/icons'

interface InfoBannerProps {
  message: string
}

export function InfoBanner({ message }: InfoBannerProps) {
  return (
    <div className="border-indigo-base flex gap-2 rounded-lg border bg-indigo-50 p-4">
      <InfoIconFilled className="text-indigo-base h-6 w-6 shrink-0 p-0.75" />
      <Text className="text-sm text-neutral-900">{message}</Text>
    </div>
  )
}
